import axios from "axios";
import { SERVER_API_URL } from "../apis/index";

const headers = {};

export class HttpClient {
  BASE_URL = SERVER_API_URL;
  URL = "";
  instance = null;

  constructor(url) {
    this.URL = url;
  }

  get http() {
    return this.instance != null ? this.instance : this.initHttp();
  }

  initHttp() {
    const http = axios.create({
      baseURL: this.BASE_URL,
      headers,
    });
    http.interceptors.request.use(
      (config) => {
        try {
          const token = localStorage.getItem("idToken");
          if (token != null) {
            config.headers.Authorization = `${token}`;
          }
          return config;
        } catch (error) {
          throw new Error(error);
        }
      },
      (error) => Promise.reject(error)
    );
    this.instance = http;
    return http;
  }
}

const Http = new HttpClient();

export const AxiosHttp = Http.http;
